import { Injectable, OnInit } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ActivatedRouteSnapshot, ResolveEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApplicationInsightsService {
  private routerSubscription: Subscription;

  private appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: '512c2aed-c9aa-40c7-b114-79be17fb7ca8'
    }
  });

  constructor(private router: Router) {
    this.appInsights.loadAppInsights();
    this.appInsights.addTelemetryInitializer((item)=>{
      if (item.baseType == 'RemoteDependencyData') {
        return false;
      }
      return true;
    });
    this.routerSubscription = this.router.events.pipe(filter(event => event instanceof ResolveEnd)).subscribe((event: ResolveEnd) => {
      const activatedComponent = this.getActivatedComponent(event.state.root);
      if (activatedComponent) {
        this.logPageView(`${activatedComponent.name} ${this.getRouteTemplate(event.state.root)}`, event.urlAfterRedirects);
      }
    });
  }

  setUserId(userId: string) {
    let validatedId = userId.replace(/[,;=| ]+/g, "_");
    this.appInsights.setAuthenticatedUserContext(validatedId);
  }

  clearUserId() {
    this.appInsights.clearAuthenticatedUserContext();
  }

  logPageView(name?: string, uri?: string) {
    this.appInsights.trackPageView({ name, uri });
  }

  trackEvent(event: string, properties = null) {
    let trackedEvent = { "name": event };
    // if (typeof(event)=="string") {
    //   trackedEvent = { "name": event };
    // }
    this.appInsights.trackEvent(trackedEvent, properties);
    //this.trackMixPanelEvent(event, properties);
  }

  // trackMixPanelEvent(event: string, properties = null) {
  //   try {
  //     const mixpanel = window['mixpanel'];
  //     mixpanel?.track(event, properties);
  //   }
  //   catch(error) {
  //   }
  // }

  trackError(exception) {
    this.appInsights.trackException(exception);
  }

  private getActivatedComponent(snapshot: ActivatedRouteSnapshot): any {
    if (snapshot.firstChild) {
      return this.getActivatedComponent(snapshot.firstChild);
    }

    return snapshot.component;
  }

  private getRouteTemplate(snapshot: ActivatedRouteSnapshot): string {
    let path = '';
    if (snapshot.routeConfig) {
      path += snapshot.routeConfig.path;
    }

    if (snapshot.firstChild) {
      return path + this.getRouteTemplate(snapshot.firstChild);
    }

    return path;
  }
}